export const TOGGLE_SELECT = [
  { text: "Baja", value: 3 },
  { text: "Media", value: 2 },
  { text: "Alta", value: 1 }
];

export const CLASS_PRIORITY_TASK = {
  1: "border-danger",
  2: "border-warning",
  3: "border-light"
};
